import { useState } from 'react';

import { CurrentCarPlaceInfoType } from '../../feature/type/CurrentCarPlaceInfoType';

/**
 * 地図中央に表示するデータの状態管理用カスタムフック
 */
export const useStateCenterCoordinates = () => {
	const [centeredCurrentCarPlaceInfo, setCenteredCurrentCarPlaceInfo] = useState<CurrentCarPlaceInfoType>(); // 中央表示する車両の現在地情報

	return {
		centeredCurrentCarPlaceInfo,
		setCenteredCurrentCarPlaceInfo,
	};
};
